import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'reboron/DropModal'
import { FormattedMessage } from 'react-intl'
import DropdownList from 'react-widgets/lib/DropdownList'
import firstBy from 'thenby'

import QuestIcon from '../../mini/QuestIcon'

import { messages } from '../../../utils/messages/placeholder'
import { send, cancel } from '../../../utils/messages'
import {
  assignmentCancelClick,
  assignQuestToUser
} from '../../../actions/assignment'

export default class AssignmentModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      assignedUser: {},
      message: ''
    }
    this.onMessageChangeBound = this.onMessageChange.bind(this)
    this.onCreateAssignmentClickBound = this.onCreateAssignmentClick.bind(this)
    this.onSetAssignedToUserBound = this.onSetAssignedToUser.bind(this)
    this.closeModalBound = this.closeModal.bind(this)
    this.cancelAssignmentClickBound = this.cancelAssignmentClick.bind(this)
  }

  componentDidMount() {
    this.showModal()
    document.getElementsByTagName('html')[0].style.overflow = 'hidden'
  }

  componentWillUnmount() {
    document.getElementsByTagName('html')[0].style.overflow = 'scroll'
  }

  render() {
    const modalStyle = {
      maxHeight: 'calc(100% - 100px)',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      minWidth: '500px',
      background: '#fff',
      overflow: 'visible',
      borderRadius: '6px'
    }

    const contentStyle = {
      backgroundColor: '#fff',
      height: '100%',
      borderRadius: '6px'
    }
    const { quest, users, isQuestCopyEditorOrQuestAuthorOrQuestManager } =
      this.props
    const { intl } = this.context
    const placeholderMessages = {
      selectAPeer: intl.formatMessage(messages.selectAPeer),
      writeThemAMessage: intl.formatMessage(messages.writeThemAMessage)
    }

    const usersOptions = this.mapList(users)

    return (
      <Modal
        ref="modal"
        className={'assignment-modal'}
        modalStyle={modalStyle}
        contentStyle={contentStyle}
        closeOnClick={true}
        onHide={this.closeModalBound}
      >
        <div className="top">
          <div className="assignment-icons">
            <QuestIcon heightWidth={47} icon_image_url={quest.icon_image_url} />
            <div className="arrow" />
            <div className="smiley" />
          </div>
          <h1>
            <FormattedMessage
              id={'AssignmentModal.AssignThisQuest'}
              defaultMessage={'Assign this Quest'}
            />
          </h1>
        </div>
        <div className="bottom">
          {isQuestCopyEditorOrQuestAuthorOrQuestManager && (
            <div className="guidance">
              <FormattedMessage
                id={'AssignmentModal'}
                defaultMessage={
                  "Collaborate on this quest by assigning it to someone in your learning community to review. You can still work on your quest while it's assigned to someone else."
                }
              />
            </div>
          )}
          <div className="assignment-select">
            <div className="label">
              <FormattedMessage
                id={'AssignmentModal.AssignThisQuestTo'}
                defaultMessage={'Assign this quest to:'}
              />
            </div>
            <DropdownList
              placeholder={placeholderMessages.selectAPeer}
              data={usersOptions}
              textField={'label'}
              valueField={'id'}
              onSelect={this.onSetAssignedToUserBound}
              filter
            />
          </div>
          <textarea
            placeholder={placeholderMessages.writeThemAMessage}
            onChange={this.onMessageChangeBound}
          />
          <div className="actions">
            <div
              className="button btn-secondary-small modal-cancel"
              onClick={this.cancelAssignmentClickBound}
            >
              {cancel}
            </div>
            <div
              className={`button btn-primary-small modal-confirm ${
                Object.keys(this.state.assignedUser).length === 0
                  ? 'disabled'
                  : ''
              }`}
              onClick={this.onCreateAssignmentClickBound}
            >
              {send}
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  onSetAssignedToUser(value) {
    this.setState({ assignedUser: value })
  }

  onMessageChange(e) {
    this.setState({ message: e.currentTarget.value })
  }

  async onCreateAssignmentClick() {
    await this.props.dispatch(
      assignQuestToUser(
        this.state.assignedUser.value,
        this.state.message,
        this.props.quest.id,
        this.props.user
      )
    )
    this.setState({
      assignedUser: {},
      message: ''
    })
    this.refs.modal.hide()
  }

  showModal() {
    this.refs.modal.show()
  }

  cancelAssignmentClick() {
    this.refs.modal.hide()
  }

  closeModal() {
    this.props.dispatch(assignmentCancelClick())
  }

  mapList(arr) {
    const { quest } = this.props
    return arr
      .map(function (el) {
        let author = false
        if (quest.author_ids.includes(el.id)) {
          author = true
        }
        return {
          value: el.id,
          label: el.name,
          sort: el.name.trim().toLowerCase(),
          author: author
        }
      })
      .sort(firstBy('author', -1).thenBy(this.sortByName))
  }

  sortByName(a, b) {
    // allows case-insensitive sort
    return a.sort.localeCompare(b.sort)
  }
}

AssignmentModal.contextTypes = {
  intl: PropTypes.object.isRequired
}

AssignmentModal.propTypes = {
  wrapperClass: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  quest: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  isQuestCopyEditorOrQuestAuthorOrQuestManager: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/assignment/AssignmentModal.js